module.exports = __webpack_public_path__ + "static/media/yamagato.d6b5bd92.webp";